export default {
  setStopList(state, payload) {
    state.stop_list = payload
  },
  setOrganizationsList(state, payload) {
    state.my_organizations_list = payload
  },
  setChildListOrganizators(state, payload) {
    state.childListOrganizators = payload
  },
}